


































































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { NOTICE_BOARD, CONST_NOTICE_BOARD } from '@/services/shared';
import { NoticeBoardListDto, NoticeBoardDto, AdminDto } from '@/dto';
import { Pagination } from '@/common';
import AdminService from '../../../services/admin.service';
import NoticeBoardService from '../../../services/notice-board.service';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'NoticeBoardList',
})
export default class NoticeBoardList extends BaseComponent {
  private noticeBoardSearchDto = new NoticeBoardListDto();
  private pagination = new Pagination();
  private noticeBoardTypes: NOTICE_BOARD[] = [...CONST_NOTICE_BOARD];
  private noticeBoardTotalCount = null;
  private noticeBoardList: NoticeBoardDto[] = null;
  private totalPage = null;
  private dataLoading = false;

  private adminList: AdminDto[] = [];

  findAdmin() {
    AdminService.findForSelect().subscribe(res => {
      if (res) {
        this.adminList = res.data;
      }
    });
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.noticeBoardSearchDto = new NoticeBoardListDto();
      this.findAll();
    }
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.noticeBoardSearchDto, this.pagination);
    }
    NoticeBoardService.findAll(
      this.noticeBoardSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.noticeBoardList = res.data.items;
        this.noticeBoardTotalCount = res.data.totalCount;
      }
    });
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.noticeBoardSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.findAdmin();
  }
}
